/* unplugin-vue-components disabled */import script from "./sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=56ebeca8&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_2s7cwfl64decoaat2pz2tykl6i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ebeca8"]])

export default __exports__